import {
  buildComponentImportMap,
  COMPONENT_IMPORT_MAP_ID,
  ComponentImportMap
} from "@shared/component-import-map"

const installImportMap = (imports: Record<string, string>) => {
  const existing = document.querySelector<HTMLScriptElement>(
    `#${COMPONENT_IMPORT_MAP_ID}`
  )

  if (existing) return false

  const script = document.createElement("script")

  script.id = COMPONENT_IMPORT_MAP_ID
  script.type = "importmap"
  script.textContent = JSON.stringify({ imports })
  document.head.appendChild(script)

  return true
}

// Must match backend ARTIFACT_BASE_URL so @movement/* resolves to the artifacts Rails writes.
const installAppImportMap = (componentImportMap?: ComponentImportMap | null) =>
  installImportMap(
    buildComponentImportMap(
      process.env.VUE_APP_ARTIFACT_BASE_URL,
      componentImportMap?.imports
    ).imports
  )

export { installAppImportMap }
